import React, { memo } from 'react';

import { useGetImportHistoryQuery } from '../../../../api';
import { ImportHistory } from '../../../../components/ImportHistory';
import { IMPORT_TYPES } from '../../../../constants/discovery';

export const ImportHistoryPanel = memo(({ orgId, importType }) => {
    const { data: historyData, isLoading: isLoadingHistory } = useGetImportHistoryQuery(
        { orgId, toolId: importType },
        { skip: !orgId, refetchOnMountOrArgChange: true, keepUnusedDataFor: 0 },
    );

    if (!isLoadingHistory && !historyData?.content?.length) {
        return null;
    }

    return <ImportHistory historyData={historyData?.content} isLoading={isLoadingHistory} />;
});
